import styled from "styled-components";

const PaxErrorButtons = styled.div`
  display: flex;
  flex-direction: column;
`;

export default PaxErrorButtons;
